import React from "react";
import IntegrationCard from "./IntegrationCard";
import SettingsPageWrapper from "../../../shared/SettingsPageWrapper";

const SettingsIntegrationDetails = (props) => {
  const { settingsPath, lastEditedAt, changelogVersions, ...integrationProps } = props;

  return (
    <SettingsPageWrapper settingsPath={settingsPath} title="Integrations" lastEditedAt={lastEditedAt} changelogVersions={changelogVersions}>
      <IntegrationCard {...integrationProps} />
    </SettingsPageWrapper>
  );
};

export default SettingsIntegrationDetails;
